import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import logo from '../../static/img/logo.webp';


const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    width: '400',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(400 + theme.spacing(2 * 2))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  logo: {
    height: 60,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
  },
  text: {
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  centered: {
    marginBottom: theme.spacing(),
    textAlign: 'center',
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
});

function NotFoundPage(props) {
  const { classes } = props;
  return (
    <div className={classes.page}>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <Typography className={classes.header} color="textSecondary" variant="h4">Uh Oh!</Typography>
        <Paper className={classes.paper} elevation={1}>
          <img src={logo} alt="Nia" className={classes.logo} />
          <Grid justifyContent="center" container spacing={3}>
            <Typography className={classes.subtitle} variant="subtitle1">The page you are looking for could not be found..</Typography>
            <Typography className={classes.centered}>With the release of our new website, many pages from the old one may have been lost.</Typography>
            <Typography className={classes.text}>
              If we missed something important, please
              <Link className={classes.link} to="/contact"> contact customer support </Link>
              and we will get it sorted out.
            </Typography>
            <Typography className={classes.text} color="textSecondary">Thank you for your patience</Typography>
          </Grid>
        </Paper>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
}

NotFoundPage.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(NotFoundPage);
